import merge from 'lodash/merge';

import RestEntityAPI from './restEntityAPI';

import fetch, { toQueryString } from '../fetch';
import config from '../../config';

export const ORGANIZATIONS_BASE_URL = `${config.apiUrl}/v1/orgs`;

const options = {
  entityName: 'employers',
  endpoint: () => ORGANIZATIONS_BASE_URL,
};

const OrganizationsAPI = () => {
  const parentAPI = RestEntityAPI(options);

  const getSubOrganizationsForOrg = async (orgId, query, fetchOptions = {}, ctx = {}) => {
    const qs = toQueryString(query);
    try {
      return await fetch(`${ORGANIZATIONS_BASE_URL}/${orgId}/sub-orgs${qs}`, {
        method: 'GET',
        ...fetchOptions,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const getOrganizationsByName = async (queryParams = {}, fetchOptions = {}, ctx = {}) => {
    try {
      const response = await fetch(`${ORGANIZATIONS_BASE_URL}${toQueryString(queryParams)}`, {
        method: 'GET',
        ...fetchOptions,
        ctx,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

  const getOrganizationById = async (orgId) => {
    try {
      const response = await fetch(`${ORGANIZATIONS_BASE_URL}/${orgId}`, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      return error;
    }
  };

  return merge({}, {
    ...parentAPI,
    getSubOrganizationsForOrg,
    getOrganizationsByName,
    getOrganizationById,
  });
};

export default OrganizationsAPI;
